// src/components/ProjectCard.jsx
import React from 'react';
import ImageCarousel from './ImageCarousel';

const ProjectCard = ({ project }) => {
  return (
    <div className="glass-card">
      <ImageCarousel images={project.images} />
      
      <h3 className="card-title">{project.name}</h3>
      
      <p style={{
        color: '#94a3b8', 
        fontSize: '0.95rem', 
        lineHeight: '1.6', 
        margin: '12px 0 20px 0',
        minHeight: '60px' // Keeps cards aligned
      }}>
        {project.details}
      </p>
      
      <div style={{ marginBottom: '25px', display: 'flex', flexWrap: 'wrap' }}>
        {project.tech?.map((t, i) => (
          <span key={i} className="tech-tag">{t}</span>
        ))}
      </div>

      {project.link && (
        <a 
          href={project.link} 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            display: 'block',
            padding: '12px',
            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '12px',
            fontSize: '14px',
            fontWeight: 'bold',
            textAlign: 'center',
            boxShadow: '0 4px 15px rgba(37, 99, 235, 0.3)',
            transition: 'opacity 0.2s'
          }}
          onMouseOver={(e) => e.target.style.opacity = '0.9'}
          onMouseOut={(e) => e.target.style.opacity = '1'}
        >
          View Live Project ↗
        </a>
      )}
    </div>
  );
};

export default ProjectCard;